<template>
  <div id="upload_video_container">
    <input type="file" ref="input" accept="video/*" @change="upload" />
  </div>
</template>

<script>
import { create_video_upload } from "@/api/vod";
export default {
  name: "v_upload_video",
  data() {
    return {
      // accept:
      uploader: null,
      isStartUpload: false,
      statusText: "",
      authProgress: 0,
      canUpload: true,
      vodId: "",
      videoActiveInfo: {
        play_vid: "",
        play_auth: "",
        name: ""
      }
    };
  },
  methods: {
    upload(e) {
      let accept = this.accept || [".mp4"];
      const file = e.target.files[0];
      // console.log(".mp4".includes(file.name.toLowerCase()));
      if (!accept.some(item => file.name.toLowerCase().includes(item))) {
        this.$utils.showError("upload_file_error", {
          accept: accept.join(",")
        });
        return;
      }
      if (this.uploader == null) {
        this.uploader = this.createUploader();
      }
      this.uploader.addFile(file, null, null, null, null);
      this.$refs.input.value = "";
    },
    check_video() {
      this.$refs.input.click();
    },
    createUploader() {
      let self = this;
      // console.log(process.env.ALIYUN_REGION, "process.env.ALIYUN_REGION");
      let _data = {
        title: "",
        file_name: ""
      };
      // console.log(process.env.ALIYUN_REGION, "sssssssssss")
      let uploader = new AliyunUpload.Vod({
        partSize: 1048576,
        parallel: 5,
        retryCount: 3,
        retryDuration: 2,
        region: process.env.ALIYUN_REGION,
        userId: process.env.ALIYUN_USERID,
        // 添加文件成功
        addFileSuccess: function(uploadInfo) {
          // console.log(11111)
          self.uploader.startUpload();
        },
        // 开始上传
        onUploadstarted: function(uploadInfo) {
          _data.file_name = uploadInfo.file.name;
          _data.title = uploadInfo.file.name.substring(
            0,
            uploadInfo.file.name.lastIndexOf(".")
          );
          // console.log(uploadInfo)
          if (uploadInfo) {
            if (!self.upload_options) {
              self.$utils.showError("no_upload_parameter");
              return;
            }
            //这个文件没有上传异常
            create_video_upload(Object.assign(self.upload_options, _data)).then(
              res => {
                uploader.setUploadAuthAndAddress(
                  uploadInfo,
                  res.body.upload_auth,
                  res.body.upload_address,
                  res.body.video_id
                );
                self.uploadingVodId = res.body.vod_id;
                // self.$emit("startUpload", { uploadInfo });
                if (self.startUpload) {
                  self.startUpload(uploadInfo);
                }
                // console.log("aaaaaa")

              }
            );
            document.body.removeChild(document.getElementById("upload_video_container"))
          }
        },

        // 文件上传成功
        onUploadSucceed: uploadInfo => {
          this.$utils.showSuccess("upload_success");
          this.$emit("uploadSuccess", uploadInfo);
          if (this.uploadSuccess) {
            this.uploadSuccess(uploadInfo);
          }
        },
        // 文件上传失败
        onUploadFailed: function(uploadInfo, code, message) {
          self.$utils.showError("upload_error");
          self.uploadingVodId = "";
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function(uploadInfo, totalSize, progress) {
          self.videoActiveInfo = {
            play_auth: "",
            play_vid: "",
            name: uploadInfo.file.name
          };
          let authProgress = Math.ceil(progress * 100);
          // console.log(this.a, "aaaaaaaaaaa")
          if (self.uploadProgress) {
            self.uploadProgress({
              uploadInfo,
              totalSize,
              progress: authProgress
            });
          }
          // self.$emit("uploadProgress", {
          //   uploadInfo,
          //   totalSize,
          //   progress: authProgress
          // });
        }
      });
      return uploader;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/v_upload_video/upload_video.vue